let callBackNo = 0;
let readyFnList = [];
function generateFnName () {
	callBackNo++;
	return 'COVERAPP_CallBack_' + callBackNo;
}
let COVERAPP = {
	// 基础属性类
	Attribute: {
		// userAgent
		UA: navigator.userAgent,

		// version
		version: '1.4.0',

		// 判断是否为app
		isApp(){
			let ua = this.UA;
	    	if (/TheCover/i.test(ua)) {
	      		return true;
	    	}
	        return false;
		},

		// 判断是否是ios
		isIOS(){
			let ua = this.UA;
		    if (/ios/i.test(ua) || /iphone/i.test(ua) || /ipad/i.test(ua) || /ipod/i.test(ua)) {
		       return true;
		    }
		    return false;
		},

		// 判断是否是android
	    isAndroid () {
	    	let ua = this.UA;
	    	if (/android/i.test(ua)) {
	      		return true;
	    	}
	        return false;
	    },

	    // 获取客户端版本号
	    appVersion(){
	    	let ua = this.UA;
	    	let version = ua.split('(TheCover_')[1].split('_')[0];
	    	return version;
	    },

	    // 获取系统类型
	    systemType(){
	    	let ua = this.UA;
	    	let sys = ua.split('(TheCover_')[1].split('_')[1];
	    	return sys;
	    },

	    // 设备标识
	    deviceId(){
	    	let ua = this.UA;
	    	let id = ua.split('(TheCover_')[1].split('_')[2].split(')')[0];
	    	return id;
		},
		
		// 判断是否是微信
		isWeixin () {
			var ua = this.UA;
			if (/MicroMessenger/i.test(ua)) {
				return true;
			}
			return false;
		},

		// 判断是否是手Q
		isQQ () {
			var ua = this.UA;
			if (/qq/i.test(ua)) {
				return true;
			}
			return false;
		},

		// 是否是支付宝
		isAlipay () {
			var ua = this.UA;
			if (/alipay/i.test(ua)) {
				return true;
			}
			return false;
		},

	    // 版本比较
	    vercp(version){
	    	let appvs = this.appVersion.split('.'), vs = version.split('.');

	    	if(appvs[0] < vs[0]){
	    		return 'old';
	    	}

	    	if(appvs[0] > vs[0]){
	    		return 'new';
	    	}

	    	if(appvs[0] == vs[0] && appvs[1] < vs[1]){
	    		return 'old';
	    	}

	    	if(appvs[0] == vs[0] && appvs[1] > vs[1]){
	    		return 'new';
	    	}

	    	if(appvs[0] == vs[0] && appvs[1] == vs[1] && appvs[2] < vs[2]){
	    		return 'old';
	    	}

	    	if(appvs[0] == vs[0] && appvs[1] == vs[1] && appvs[2] > vs[2]){
	    		return 'new';
	    	}

	    	if(appvs[0] == vs[0] && appvs[1] == vs[1] && appvs[2] == vs[2]){
	    		return 'new';
	    	}

	    }

	},

	// 界面类
	UI: {
		// 对话框组
		Dialog(obj){
			let funName = generateFnName()
			window[funName] = obj.callback;
			obj.callback = funName;
			if(COVERAPP.Attribute.isIOS()){
				window.webkit.messageHandlers.Dialog.postMessage(obj);
				return false;
			}

			if(COVERAPP.Attribute.isAndroid()){
				AndroidBridging.dialog(JSON.stringify(obj));
				return false;
			}
			
		},

		// alert
		alert(msg){
			this.Dialog({
				title: '',
	    		msg: msg,
	    		buttons: ['确定'],
	    		callback(ret){
	    			
	    		}
			});
		},

		// 沉浸式
		immersive (obj) {
			let funName = generateFnName()
			window[funName] = obj.callback;
			obj.callback = funName;
			if (COVERAPP.Attribute.isIOS()) {
				window.webkit.messageHandlers.Immersive.postMessage(obj);
				return false;
			}

			if (COVERAPP.Attribute.isAndroid()) {
				AndroidBridging.immersive(JSON.stringify(obj));
				return false;
			}
		},

		// 图集预览
		previewImage(obj){
			if(COVERAPP.Attribute.isIOS()){
				window.webkit.messageHandlers.PreviewImage.postMessage(obj);
				return false;
			}

			if(COVERAPP.Attribute.isAndroid()){
				AndroidBridging.previewImage(JSON.stringify(obj));
				return false;
			}
		}
	},

	// 功能方法类
	Method: {
		// 分享
		Share(obj){
			let funName = generateFnName()
			window[funName] = obj.callback;
			obj.callback = funName;
			if(COVERAPP.Attribute.isIOS()){
				window.webkit.messageHandlers.Share.postMessage(obj);
				return false;
			}

			if(COVERAPP.Attribute.isAndroid()){
				AndroidBridging.share(JSON.stringify(obj));
				return false;
			}
			
		},

		// 被动分享
		onshare(obj) {
			let funName = generateFnName()
			window[funName] = obj.callback;
			obj.callback = funName;
			if (COVERAPP.Attribute.isIOS()) {
				try {
					window.webkit.messageHandlers.onShare.postMessage(obj);
				} catch (e) {
				}
			} else {
				if (window.AndroidBridging) {
					window.AndroidBridging.onShare(JSON.stringify(obj));
				}
			}
		},

		// 打开登录
		OpenLogin(obj){
			let funName = generateFnName()
			window[funName] = obj.callback;
			obj.callback = funName;
			if(COVERAPP.Attribute.isIOS()){
				window.webkit.messageHandlers.Login.postMessage(obj);
				return false;
			}

			if(COVERAPP.Attribute.isAndroid()){
				console.log('denglu');
				AndroidBridging.login(JSON.stringify(obj));
				return false;
			}
			
		},

		// 获取用户信息
		GetUser(obj) {
			let funName = generateFnName()
			window[funName] = obj.callback;
			obj.callback = funName;
			if (COVERAPP.Attribute.isIOS()) {
				// 老版本User，新版本wcUser
				window.webkit.messageHandlers.wcUser.postMessage(obj);
				return false;
			}
			if (COVERAPP.Attribute.isAndroid()) {
				// 老版本user，新版本wcuser
				AndroidBridging.wcuser(JSON.stringify(obj));
				return false;
			}
		},

		// 获取通知是否打开（2018世界杯使用）callback 必传
		getNotificationStatus (obj) {
			let funName = generateFnName()
			window[funName] = obj.callback;
			obj.callback = funName;
			if(COVERAPP.Attribute.isIOS()){
				window.webkit.messageHandlers.getNotificationStatus.postMessage(obj);
				return false;
			}
			if(COVERAPP.Attribute.isAndroid()){
				AndroidBridging.getNotificationStatus(JSON.stringify(obj));
				return false;
			}
		},

		// 去设置页面 （2018世界杯使用）
		goSettingNotification () {
			if (COVERAPP.Attribute.isIOS()) {
				window.webkit.messageHandlers.goSettingNotification.postMessage('');
				return false;
			}
			if (COVERAPP.Attribute.isAndroid()) {
				AndroidBridging.goSettingNotification();
				return false;
			}
		},

		/**
		 * 生成签名
		 * @param  {Object} obj 参数对象
		 * @param  {string} obj.callback 回调函数名 非必须  参数JSON字符串，包含status('success', 'cancel')
		 */
		generateSign (obj) {
			let timestamp = new Date().getTime();
			let token = '';
			let account = Math.round(Math.random() * 10000000);
			let params = {
				timestamp: timestamp,
				token: token,
				account: account
			};
			let funName = generateFnName()
			// 之前客iOS客户端没有返回传递过去的参数，需要自己把参数传给回调
			window[funName] = function (data) {
				obj.callback.call(window, data, params);
			};
			params.callback = funName;
			if (COVERAPP.Attribute.isIOS()) {
				window.webkit.messageHandlers.generateSign.postMessage(params);
				return false;
			}
			if (COVERAPP.Attribute.isAndroid()) {
				AndroidBridging.generateSign(JSON.stringify(params));
				return false;
			}
		},

		/**
		 * 调起绑定手机号
		 * @param  {Object} obj 参数对象
		 * @param  {string} obj.callback 回调函数名
		 */
		bindMobile (obj) {
			let funName = generateFnName();
			window[funName] = obj.callback;
			obj.callback = funName;
			if (COVERAPP.Attribute.isIOS()) {
				window.webkit.messageHandlers.bindMobile.postMessage(obj);
				return false;
			}
			if (COVERAPP.Attribute.isAndroid()) {
				AndroidBridging.bindMobile(JSON.stringify(obj));
				return false;
			}
		},

		/**
		 * 调起动态发布
		 * @param  {Object} obj (dynamicId,dynamicTitle) 参数对象
		 * @param  {string} obj.callback 回调函数名
		 */
		goDynamicPublish (obj) {
			let funName = generateFnName();
			window[funName] = obj.callback;
			obj.callback = funName;
			if (COVERAPP.Attribute.isIOS()) {
				window.webkit.messageHandlers.goDynamicPublish.postMessage(obj);
				return false;
			}
			if (COVERAPP.Attribute.isAndroid()) {
				AndroidBridging.goDynamicPublish(JSON.stringify(obj));
				return false;
			}
		},

		// 微信授权
		wxAuthorize (obj) {
			let funName = generateFnName();
			window[funName] = obj.callback;
			obj.callback = funName;
			if (COVERAPP.Attribute.isIOS()) {
				window.webkit.messageHandlers.wxAuthorize.postMessage(obj);
				return false;
			}
			if (COVERAPP.Attribute.isAndroid()) {
				AndroidBridging.wxAuthorize(JSON.stringify(obj));
				return false;
			}
		},

		/**
		 * 复制到剪贴板
		 * @param  {Object} obj 参数对象
		 * @param  {string} obj.text 复制的文本
		 * @param  {string} obj.callback 回调函数名 非必须  参数JSON字符串，包含status('success', 'cancel')
		 */
		copyToClipborad (obj) {
			let funName = generateFnName()
			window[funName] = obj.callback;
			obj.callback = funName;
			if (COVERAPP.Attribute.isIOS()) {
				window.webkit.messageHandlers.copyToClipborad.postMessage(obj);
				return false;
			}
			if (COVERAPP.Attribute.isAndroid()) {
				AndroidBridging.copyToClipborad(JSON.stringify(obj));
				return false;
			}
		},

		// 加积分, 传type
		integral (obj) {
			let funName = generateFnName();
			window[funName] = obj.callback;
			obj.callback = funName;
			if (COVERAPP.Attribute.isIOS()) {
				window.webkit.messageHandlers.integral.postMessage(obj);
				return false;
			}
			if (COVERAPP.Attribute.isAndroid()) {
				AndroidBridging.integral(JSON.stringify(obj));
				return false;
			}
		},
		
		// 去积分商城
		goIntegralMall () {
			if (COVERAPP.Attribute.isIOS()) {
				window.webkit.messageHandlers.goIntegralMall.postMessage('');
				return false;
			}
			if (COVERAPP.Attribute.isAndroid()) {
				AndroidBridging.goIntegralMall();
				return false;
			}
		},

		// 返回
		Back(){
			if(COVERAPP.Attribute.isIOS()){
				window.webkit.messageHandlers.Back.postMessage('');
				return false;
			}

			if(COVERAPP.Attribute.isAndroid()){
				AndroidBridging.back();
				return false;
			}
		},

		/**
		 * 封面日报截长图并保存到相册
		 */
		SaveLocalDailyImage(obj) {
			let funName = generateFnName()
			window[funName] = obj.callback;
			obj.callback = funName;
			if (COVERAPP.Attribute.isIOS()) {
				window.webkit.messageHandlers.saveLocalDailyImage.postMessage(obj);
				return false;
			}

			if (COVERAPP.Attribute.isAndroid()) {
				AndroidBridging.saveLocalDailyImage(JSON.stringify(obj));
				return false;
			}
		},

		//去积分任务页面
		goIntegralTask() {
			if(COVERAPP.Attribute.isIOS()) {
				window.webkit.messageHandlers.goIntegralTask.postMessage("");
				return false;
			}else if(COVERAPP.Attribute.isAndroid()){
				AndroidBridging.goIntegralTask();
				return false;
			}
		},

        /**
		 * 海报分享
		 * @param  {string} obj.image base64字符串
		 * @param  {string} obj.title 标题
		 * @param  {string} obj.desc 描述
		 * @param  {string} obj.link 链接
		 * @param  {string} obj.imgUrl 小图标
		 * @param  {string} obj.callback 回调函数名 (返回对象有status --状态 和 origin --渠道)
		 */
        shareImage (obj) {
			let funName = generateFnName()
			window[funName] = obj.callback;
			obj.callback = funName;
			if (COVERAPP.Attribute.isIOS()) {
				window.webkit.messageHandlers.shareImage.postMessage(obj);
				return false;
			}

			if (COVERAPP.Attribute.isAndroid()) {
				AndroidBridging.shareImage(JSON.stringify(obj));
				return false;
			}
		},
	},

	// ready方法 需要确保桥可以使用是，放在ready方法里
	ready (fn) {
		readyFnList.push(fn);
	}
};
window.COVERAPP_CallBack_ready = function () {
	for (let i = 0; i < readyFnList.length; ++i) {
		readyFnList[i].call();
	}
}

export default COVERAPP = COVERAPP;